module.exports = "/_next/static/images/springfield-ma-9e1488b7a1e694a62f98382e2c263bb3.jpg";